import $ from 'wee-dom';
import $events from 'wee-events';
import { _body, _doc } from 'core/variables';
import Tabbable from '../../scripts/tabbable';
import KeyHelper from '../../scripts/keyhelper';
import { disabled } from '../../scripts/classes';

function loadApi() {
    const tag = _doc.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = _doc.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

export default class Video {
    constructor($overlay) {
        this.$overlay = $overlay;
        this.$controls = $(':controls');
        this.$openVideo = $(':openVideo');
        this.$closeVideo = $(':closeVideo');
        this.$body = $(_body);
        this.player = null;
        this.tabbable = null;
        this.isOpen = false;

        loadApi();
    }

    open() {
        this.$overlay.show();
        this.isOpen = true;
        this.tabbing();

        this.$body.addClass(disabled);
    }

    close() {
        const iframe = this.$overlay.find('iframe');
        const message = {
            event: 'command',
            func: 'stopVideo',
            args: '',
        };

        if (iframe.length) {
            iframe[0].contentWindow.postMessage(JSON.stringify(message), '*');
        }

        this.$overlay.hide();
        this.isOpen = false;

        this.$body.removeClass(disabled);
    }

    tabbing() {
        this.tabbable = new Tabbable({
            el: this.$overlay,
            callback: () => {
                this.tabbable.$firstEl[0].focus();
            },
        });

        $events.on({
            [this.$openVideo.sel]: {
                keydown(e) {
                    if (KeyHelper.isTab(e)) {
                        e.preventDefault();
                    }
                },
                keyup: (e) => {
                    if (KeyHelper.isTab(e)) {
                        this.$closeVideo[0].focus();
                    }
                },
            },
        });
    }
}
